import { HubApiMethods } from '../../constants/HubApiMethods';
import { HubJsonRpcRequest } from '../../api/HubJsonRpcRequest';

import { AcceptPolicyResponse } from '../../api/hub-responses/accept-policy-response';
import { HubApiError } from '../../domains/valueObject/SwitchUserProgressResponses';
import { container } from '../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../utils/container/service-ids';
import { FlagNames } from '../../utils/feature-flags/flag-names';
import { getHubApi } from '../modules/accountServiceApi/getAccountServiceApi';


export type AcceptPolicyRequest = {
    suid: string,
    policy_ids: number[]
    token: string
}

export function acceptPolicy(data: AcceptPolicyRequest): Promise<AcceptPolicyResponse|HubApiError> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<AcceptPolicyResponse, AcceptPolicyRequest>(
            HubApiMethods.ACCEPT_POLICY,
            data,
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.acceptPolicy(window.app.deviceIdentifier, data) as Promise<AcceptPolicyResponse>;
    }
}
